import { React, Component } from 'react'
import { connect } from "react-redux"
import * as actions from "../actions"

import NavBar from "./home/NavBar"
import Clients from "./home/clients/Clients"
import NewClient from "./home/clients/NewClient"
import ViewClient from './home/clients/ViewClient'

import Documents from './home/documents/Documents'
import DocumentLocations from './home/documents/DocumentLocations'
import ClientDocs from './home/clients/client-forms/ClientDocs'

import Users from "./home/users/Users"
import NewUser from "./home/users/NewUser"
import ViewUser from './home/users/ViewUser'

import Roles from "./home/roles/Roles"
import NewRole from "./home/roles/NewRole"
import ViewRole from "./home/roles/ViewRole"

import Reports from "./home/reports/Reports"
import NewReportCase from "./home/reports/NewReportCase"
import ViewReportCase from "./home/reports/ViewReportCase"
import QualityReview from "./home/quality/QualityReview"
import { deriveRoleFlags } from './home/homePermissions'
import {
    bootstrapProtectedSession,
    hasVerifiedSession,
    isSessionExpiryError,
    redirectToLogin,
    startSessionMonitor
} from '../auth/sessionExpiry'

import { Button, Container, Loader, Message } from 'semantic-ui-react'

var clientDocsDict = { }

class App extends Component {

    state = { activeItem: "clients", reportCasePrefill: null, sessionStatus: 'checking' }

    constructor(props) {
        super(props)
        this.handleChangeItemNavBar = this.handleChangeItemNavBar.bind(this)
        this.handleChangeItemClient = this.handleChangeItemClient.bind(this)
        this.handleChangeItemUser = this.handleChangeItemUser.bind(this)
        this.handleChangeItemRole = this.handleChangeItemRole.bind(this)
        this.handleViewDoc = this.handleViewDoc.bind(this)
        this.handleUpdateClientDocs = this.handleUpdateClientDocs.bind(this)
        this.handleResetDocsRedirect = this.handleResetDocsRedirect.bind(this)
        this.handleBackClickedClients = this.handleBackClickedClients.bind(this)
        this.handleBackClickedUsers = this.handleBackClickedUsers.bind(this)
        this.handleBackClickedRoles = this.handleBackClickedRoles.bind(this)
        this.handleBackClickedClientDocs = this.handleBackClickedClientDocs.bind(this)
        this.handleCreateClientSuccess = this.handleCreateClientSuccess.bind(this)
        this.handleEditClientSuccess = this.handleEditClientSuccess.bind(this)
        this.handleDeleteClientSuccess = this.handleDeleteClientSuccess.bind(this)
        this.handleCreateUserSuccess = this.handleCreateUserSuccess.bind(this)
        this.handleEditUserSuccess = this.handleEditUserSuccess.bind(this)
        this.handleDeleteUserSuccess = this.handleDeleteUserSuccess.bind(this)
        this.handleCreateRoleSuccess = this.handleCreateRoleSuccess.bind(this)
        this.handleEditRoleSuccess = this.handleEditRoleSuccess.bind(this)
        this.handleDeleteRoleSuccess = this.handleDeleteRoleSuccess.bind(this)
        this.handleChangeItemReportCase = this.handleChangeItemReportCase.bind(this)
        this.handleBackClickedReports = this.handleBackClickedReports.bind(this)
        this.handleCreateReportCaseSuccess = this.handleCreateReportCaseSuccess.bind(this)
        this.handleEditReportCaseSuccess = this.handleEditReportCaseSuccess.bind(this)
        this.handleCreateReportCaseFromClient = this.handleCreateReportCaseFromClient.bind(this)
    }

    componentDidMount() {
        this.componentIsMounted = true
        this.bootstrapSession()
    }

    componentWillUnmount() {
        this.componentIsMounted = false
        this.stopSessionMonitor?.()
    }

    componentDidUpdate(previousProps) {
        const rolesChanged = previousProps.roles !== this.props.roles
        const userChanged = previousProps.user !== this.props.user

        if (userChanged && this.props.user?._id) {
            if (this.props.user.secondFactorVerified === true) {
                window.sessionStorage.setItem('verified2FA', 'yup')
            } else {
                redirectToLogin()
            }
        }

        if (rolesChanged || userChanged) {
            const flags = deriveRoleFlags(this.props.user, this.props.roles)

            this.setState({
                permissions: flags.permissions,
                canExportClientInfoForm: flags.canExportClientInfoForm,
                canFilterByFYE: flags.canFilterByFYE,
                canFilterByMonthOfAgreement: flags.canFilterByMonthOfAgreement,
                canAddClientDocumentRecord: flags.canAddClientDocumentRecord,
                canDeleteClientDocumentRecord: flags.canDeleteClientDocumentRecord,
                canViewReports: flags.canViewReports,
                canViewQualityReview: flags.canViewQualityReview,
                canDeleteReports: flags.canDeleteReports,
                canExportReports: flags.canExportReports,
                isAdmin: flags.isAdmin
            })
        }
    }

    canViewReports() {
        return !!this.state.canViewReports
    }

    canViewUsers() {
        return !!this.state.isAdmin
    }

    canViewRoles() {
        return !!this.state.isAdmin
    }

    canViewQualityReview() {
        // Preserve the existing report-role access while also honouring the
        // dedicated Quality Check permission used by the isolated service.
        return !!this.state.isAdmin || !!this.state.canViewReports || !!this.state.canViewQualityReview
    }

    bootstrapSession = async () => {
        if (this.componentIsMounted) this.setState({ sessionStatus: 'checking' })

        try {
            const result = await bootstrapProtectedSession({
                fetchUser: this.props.fetchUser,
                fetchRoles: this.props.fetchRoles,
                onUnauthenticated: redirectToLogin
            })
            if (!result.authenticated || !this.componentIsMounted) return

            window.sessionStorage.setItem('verified2FA', 'yup')
            this.setState({ sessionStatus: 'authenticated' })
            this.stopSessionMonitor?.()
            this.stopSessionMonitor = startSessionMonitor(this.recheckSession)
        } catch (error) {
            if (!this.componentIsMounted || isSessionExpiryError(error)) return
            this.setState({ sessionStatus: 'error' })
        }
    }

    recheckSession = async () => {
        try {
            const user = await this.props.fetchUser()
            if (!hasVerifiedSession(user)) redirectToLogin()
        } catch (error) {
            if (!isSessionExpiryError(error)) {
                // Keep the current screen usable during a temporary network/server failure.
            }
        }
    }

    renderCreateSuccessMessage() {
        if (this.state.showCreateClientSuccess) {
            return (<Container>
                <br />
                <Message success header='New client successfully created.' content='You can find and edit the client on this page.'/>
            </Container>)
        } else if (this.state.showCreateUserSuccess) {
            return (<Container>
                <br />
                <Message success header='New user successfully created.' content='You can find and edit the user on this page.'/>
            </Container>)
        } else if (this.state.showCreateRoleSuccess) {
            return (<Container>
                <br />
                <Message success header='New role successfully created.' content='You can find and edit the role on this page.'/>
            </Container>)
        } else if (this.state.showCreateReportCaseSuccess) {
            return (<Container>
                    <br />
                    <Message success header='New workflow successfully created.' />
                </Container>)
        } else {
            return
        }
    }

    renderEditSuccessMessage() {
        if (this.state.showEditClientSuccess) {
            return (<Container>
                <br />
                <Message success header='Client changes successfully saved' content={this.state.savedClientName} />
            </Container>)
        } else if (this.state.showEditUserSuccess) {
            return (<Container>
                <br />
                <Message success content='User changes successfully saved.'/>
            </Container>)
        } else if (this.state.showEditRoleSuccess) {
            return (<Container>
                <br />
                <Message success content='Role changes successfully saved.'/>
            </Container>)
        } else {
            return
        }
    }

    renderDeleteSuccessMessage() {
        if (this.state.showDeleteClientSuccess) {
            return (<Container>
                <br />
                <Message success content='Client successfully deleted.'/>
            </Container>)
        } else if (this.state.showDeleteUserSuccess) {
            return (<Container>
                <br />
                <Message success content='User successfully deleted.'/>
            </Container>)
        } else if (this.state.showDeleteRoleSuccess) {
            return (<Container>
                <br />
                <Message success content='Role successfully deleted.'/>
            </Container>)
        } else {
            return
        }
    }

    renderContent() {
        const { keyForClientDocs, clientIDForViewDoc, docsRedirect, recordIDRedirect, canAddClientDocumentRecord, canDeleteClientDocumentRecord } = this.state
        switch (this.state.activeItem) {
            case "clients":
                return <Clients onChangeItem={this.handleChangeItemClient} onDeleteSuccess={this.handleDeleteClientSuccess} permissions={this.state.permissions} canFilterByFYE={this.state.canFilterByFYE} canFilterByMonthOfAgreement={this.state.canFilterByMonthOfAgreement}/>
            case "documents":
                return <Documents handleViewDoc={this.handleViewDoc} onViewLocations={() => this.setState({ activeItem: 'doc-locations' })} />
            case 'doc-locations':
                return <DocumentLocations onBack={this.handleBackClickedClientDocs} handleViewDoc={this.handleViewDoc} />
            case "view-doc":
                return <ClientDocs updateClientDocs={this.handleUpdateClientDocs} clientID={clientIDForViewDoc} savedDict={clientDocsDict} key={keyForClientDocs} redirectTo={docsRedirect} recordIDRedirect={recordIDRedirect} resetDocsRedirect={this.handleResetDocsRedirect}
                        canCreateDoc={canAddClientDocumentRecord} canDeleteDoc={canDeleteClientDocumentRecord} isFromDocuments onBackClicked={this.handleBackClickedClientDocs}/>
            case "users":
                if (!this.canViewUsers()) { return ( <Container> <Message negative> You do not have permission to view staff. </Message> </Container> ) }
                return <Users onChangeItem={this.handleChangeItemUser} onDeleteSuccess={this.handleDeleteUserSuccess}/>
            case "roles":
                if (!this.canViewRoles()) { return ( <Container> <Message negative> You do not have permission to view roles. </Message> </Container> ) }
                return <Roles onChangeItem={this.handleChangeItemRole} onDeleteSuccess={this.handleDeleteRoleSuccess}/>
            case "new-client":
                return <NewClient onCreateSuccess={this.handleCreateClientSuccess} onCancel={this.handleBackClickedClients} permissions={this.state.permissions}/>
            case "view-client":
                return <ViewClient clientToView={this.state.clientToView} onBackClicked={this.handleBackClickedClients} permissions={this.state.permissions} canExportClientInfoForm={this.state.canExportClientInfoForm} canCreateDoc={canAddClientDocumentRecord}/>
            case "edit-client":
                return <NewClient isEditing clientToEdit={this.state.clientToEdit} onEditSuccess={this.handleEditClientSuccess} onCancel={this.handleBackClickedClients} permissions={this.state.permissions} canExportClientInfoForm={this.state.canExportClientInfoForm}
                        canCreateDoc={canAddClientDocumentRecord} canDeleteDoc={canDeleteClientDocumentRecord} onCreateReportCase={() => this.handleCreateReportCaseFromClient(this.state.clientToEdit)}/>
            case "new-user":
                return <NewUser onCreateSuccess={this.handleCreateUserSuccess} onCancel={this.handleBackClickedUsers}/>
            case "view-user":
                return <ViewUser userToView={this.state.userToView} onBackClicked={this.handleBackClickedUsers}/>
            case "edit-user":
                if (!this.canViewUsers()) { return ( <Container> <Message negative> You do not have permission to edit staff. </Message> </Container> ) }
                return <NewUser isEditing userToEdit={this.state.userToEdit} onEditSuccess={this.handleEditUserSuccess} onCancel={this.handleBackClickedUsers}/>
            case "new-role":
                return <NewRole roleToEdit={this.state.roleToEdit} onCreateSuccess={this.handleCreateRoleSuccess} onCancel={this.handleBackClickedRoles}/>
            case "view-role":
                return <ViewRole roleToView={this.state.roleToView} onBackClicked={this.handleBackClickedRoles}/>
            case "edit-role":
                if (!this.canViewRoles()) { return ( <Container> <Message negative> You do not have permission to view roles. </Message> </Container> ) }
                return <NewRole isEditing roleToEdit={this.state.roleToEdit} onEditSuccess={this.handleEditRoleSuccess} onCancel={this.handleBackClickedRoles}/>
            case "reports":
                if (!this.canViewReports()) { return ( <Container> <Message negative> You do not have permission to view reports. </Message> </Container> ) }
                return <Reports onChangeItem={this.handleChangeItemReportCase} canExportReports={!!this.state.canExportReports} canDeleteReports={!!this.state.canDeleteReports} />
            case "quality-review":
                if (!this.canViewQualityReview()) { return ( <Container> <Message negative> You do not have permission to use quality review. </Message> </Container> ) }
                return <QualityReview />
            case "new-report-case":
                return <NewReportCase prefill={this.state.reportCasePrefill} onCreateSuccess={this.handleCreateReportCaseSuccess} onCancel={this.handleBackClickedReports} />
            case "view-report-case":
                return <ViewReportCase reportCaseToView={this.state.reportCaseToView} onBackClicked={this.handleBackClickedReports} onEditSuccess={this.handleEditReportCaseSuccess} />
            default: 
                return
        }
    }

    render() {
        if (this.state.sessionStatus === 'checking') {
            return <Loader active inline='centered' content='Checking your session…' />
        }
        if (this.state.sessionStatus === 'error') {
            return (
                <Container text style={{ marginTop: 48 }}>
                    <Message negative>
                        <Message.Header>We could not verify your session</Message.Header>
                        <p>Check your connection and try again. You will not be signed out for a temporary connection problem.</p>
                        <Button onClick={this.bootstrapSession}>Try again</Button>
                    </Message>
                </Container>
            )
        }
        if (!this.state.activeItem || !hasVerifiedSession(this.props.user)) {
            return null
        }
        return (
            <div>
                <NavBar activeItem={this.state.activeItem} onChangeItem={this.handleChangeItemNavBar} isAdmin={!!this.state.isAdmin} canViewReports={!!this.state.canViewReports} canDeleteReports={!!this.state.canDeleteReports} canViewQualityReview={this.canViewQualityReview()} user={this.props.user} />
                {this.renderCreateSuccessMessage()}
                {this.renderEditSuccessMessage()}
                {this.renderDeleteSuccessMessage()}
                {this.renderContent()}
            </div>
        )
    }

    handleChangeItemNavBar(item) {
        this.setState({ activeItem: item, 
                        showCreateClientSuccess: false, showEditClientSuccess: false, showDeleteClientSuccess: false,
                        showCreateUserSuccess: false, showEditUserSuccess: false, showDeleteUserSuccess: false,
                        showCreateRoleSuccess: false, showEditRoleSuccess: false, showDeleteRoleSuccess: false })
    }

    handleChangeItemClient(item, client) {
        if (client) {
            if (item === 'view-client') this.setState({ clientToView: client})
                else if (item === 'edit-client') this.setState({ clientToEdit: client })
        }
        this.setState({ activeItem: item, showCreateClientSuccess: false, showEditClientSuccess: false, showDeleteClientSuccess: false,
                        showCreateUserSuccess: false, showEditUserSuccess: false, showDeleteUserSuccess: false,
                        showCreateRoleSuccess: false, showEditRoleSuccess: false, showDeleteRoleSuccess: false })
    }

    handleViewDoc(client) {
        if (client) {
            clientDocsDict = client.clientDocs
            this.setState({ activeItem: 'view-doc', clientIDForViewDoc: client._id })
        }
    }

    handleUpdateClientDocs(docs, recordID) {
        clientDocsDict = docs
        this.setState({ keyForClientDocs: Date.now(), docsRedirect: 'viewDoc', recordIDRedirect: recordID })
    }

    handleResetDocsRedirect() {
        this.setState({ docsRedirect: ''})
    }

    handleChangeItemUser(item, user) {
        if (user) {
            if (item === 'view-user') this.setState({ userToView: user})
                else if (item === 'edit-user') this.setState({ userToEdit: user })
        }
        this.setState({ activeItem: item, showCreateClientSuccess: false, showEditClientSuccess: false, showDeleteClientSuccess: false,
                        showCreateUserSuccess: false, showEditUserSuccess: false, showDeleteUserSuccess: false,
                        showCreateRoleSuccess: false, showEditRoleSuccess: false, showDeleteRoleSuccess: false })
    }

    handleChangeItemRole(item, role) {
        if (role) {
            if (item === 'view-role') this.setState({ roleToView: role})
                else if (item === 'edit-role') this.setState({ roleToEdit: role })
        }
        this.setState({ activeItem: item, showCreateClientSuccess: false, showEditClientSuccess: false, showDeleteClientSuccess: false,
                        showCreateUserSuccess: false, showEditUserSuccess: false, showDeleteUserSuccess: false,
                        showCreateRoleSuccess: false, showEditRoleSuccess: false, showDeleteRoleSuccess: false })
    }

    handleBackClickedClients() {
        this.setState({ activeItem: 'clients' })
    }

    handleBackClickedUsers() {
        this.setState({ activeItem: 'users' })
    }

    handleBackClickedRoles() {
        this.setState({ activeItem: 'roles' })
    }

    handleBackClickedClientDocs() {
        this.setState({ activeItem: 'documents' })
    }

    handleCreateClientSuccess() {
        this.setState({ activeItem: 'clients', showCreateClientSuccess: true })
    }

    handleEditClientSuccess(name) {
        // this.setState({ activeItem: 'clients', showEditClientSuccess: true, savedClientName: name })
    }

    handleDeleteClientSuccess() {
        this.setState({ activeItem: 'clients', showDeleteClientSuccess: true })
    }

    handleCreateUserSuccess() {
        this.setState({ activeItem: 'users', showCreateUserSuccess: true })
    }

    handleEditUserSuccess() {
        this.setState({ activeItem: 'users', showEditUserSuccess: true })
    }

    handleDeleteUserSuccess() {
        this.setState({ activeItem: 'users', showDeleteUserSuccess: true })
    }

    handleCreateRoleSuccess() {
        this.setState({ activeItem: 'roles', showCreateRoleSuccess: true })
    }

    handleEditRoleSuccess() {
        this.setState({ activeItem: 'roles', showEditRoleSuccess: true })
    }

    handleDeleteRoleSuccess() {
        this.setState({ activeItem: 'roles', showDeleteRoleSuccess: true })
    }

    handleChangeItemReportCase(item, reportCase) {
        if (reportCase) {
            if (item === 'view-report-case') this.setState({ reportCaseToView: reportCase })
        }

        this.setState({
            activeItem: item,
            showCreateClientSuccess: false, showEditClientSuccess: false, showDeleteClientSuccess: false,
            showCreateUserSuccess: false, showEditUserSuccess: false, showDeleteUserSuccess: false,
            showCreateRoleSuccess: false, showEditRoleSuccess: false, showDeleteRoleSuccess: false,
            showCreateReportCaseSuccess: false, showEditReportCaseSuccess: false
        })
    }

    handleBackClickedReports() {
        this.setState({ activeItem: 'reports', reportCasePrefill: null })
    }

    handleCreateReportCaseSuccess() {
        this.setState({ activeItem: 'reports', showCreateReportCaseSuccess: true })
    }

    handleEditReportCaseSuccess() {
        this.setState({ activeItem: 'reports', showEditReportCaseSuccess: true })
    }
    
    handleCreateReportCaseFromClient(client) {
        if (!client) return
        this.setState({
            activeItem: 'new-report-case',
            reportCasePrefill: { clientId: client._id, companyName: client.clientInfo?.companyName || '' }
        })
    }
}

function mapStateToProps({ user, roles, verifyToken }) {
    return { user, roles, verifyToken }
}

export default connect(mapStateToProps, actions)(App)
